/** OpenLayers grid-system factory for IrishCassini; the theatre data itself is ol-free in `IrishCassini.ts`. */
import { IRISH_CASSINI_SCHEME } from '../formatters/schemes.js';
import { createMBSGridSystem } from './shared.js';
import { IRISH_CASSINI_CLIP_POLYGON, IRISH_CASSINI_CRS, IRISH_CASSINI_PROJ4, } from './IrishCassini.js';
export function createIrishCassiniGridSystem(options) {
    return createMBSGridSystem(IRISH_CASSINI_CRS, IRISH_CASSINI_PROJ4, IRISH_CASSINI_SCHEME, IRISH_CASSINI_CLIP_POLYGON, options);
}
//# sourceMappingURL=IrishCassini.grid.js.map